import { clientApi } from 'shared/api/clientApi'
import { Response } from 'shared/models/general'

import {
  HotTour,
  Hotel,
  HotelSearch,
  ResortSearch,
  SearchHotelsResponse,
  SpecialTourByCategory,
  TourDepartureCity,
  TourSearchDestination,
} from './model'

export const SearchToursApi = {
  getDestinationsCountries() {
    return clientApi.get<Response<TourSearchDestination[]>>(
      'tours/destination/countries',
    )
  },

  getDepartureCities() {
    return clientApi.get<Response<TourDepartureCity[]>>(
      'tours/departure/cities',
    )
  },

  getNights() {
    return clientApi.get<Response<any>>('tours/nights')
  },

  getResortList({ id, townFromId }: { id: string; townFromId: number }) {
    return clientApi.get<Response<ResortSearch>>(
      `tours/andromeda/search-parameters/${id}`,
      {
        params: {
          town_from_id: townFromId,
        },
      },
    )
  },

  getHotelsList(data: HotelSearch, abort?: AbortSignal) {
    return clientApi.post<SearchHotelsResponse>('tours/hotels/search', data, {
      signal: abort,
    })
  },

  getSpecialTours() {
    return clientApi.get<Response<SpecialTourByCategory[]>>(
      `tours/special-tours`,
      {
        params: {
          group_by: 'BY_CATEGORY',
        },
      },
    )
  },

  getHotTours(townFromId?: string, abort?: AbortSignal) {
    return clientApi.get<Response<HotTour[]>>(`tours/tourvisor/hottours`, {
      params: {
        town_from_id: townFromId,
      },
      signal: abort,
    })
  },

  getHotTourDetail(tourId?: string) {
    return clientApi.get<Response<Hotel>>(`tours/tourvisor/gettour/${tourId}`)
  },
}
